import React from 'react';
import PropTypes from 'prop-types';

import modalFooterUseStyles from './modalFooterUseStyles';

const ModalFooter = ({ align, children }) => {
  const { wdsModalActions, wdsModalFooter } = modalFooterUseStyles({ align });
  return (
    <footer className={wdsModalFooter}>
      <div className={wdsModalActions}>{children}</div>
    </footer>
  );
};

ModalFooter.propTypes = {
  /**
   * Align footer content
   */
  align: PropTypes.oneOf(['left', 'right']),
  /**
   * Modal footer contents
   */
  children: PropTypes.node.isRequired,
};

ModalFooter.defaultProps = {
  align: 'left',
};

export default ModalFooter;
